import React, {useState, useRef, useEffect} from "react";
import {editAnimal, getPetURLUploadImage, setAnimal} from "../../../redux/pets/pets.actions";
import UploadPhoto from "../../Modals/UploadPhoto";
import {ReactComponent as LogoSVG} from "../../../Images/logo.svg";
import {ReactComponent as PencilSVG} from "../../../Images/pencil.svg";
import {colorBorder, colorError, colorInputBorderGrayish} from "../../../Constants/theme";
import {createPetTypeIconLookup} from "../../../utils/petTypeIcons";
import {
    Typography,
    Grid,
    FormControlLabel,
    useMediaQuery,
    TextField as RTextField,
    Box,
    Button,
    Theme,
    Select,
    MenuItem,
    makeStyles,
    Container
} from "@material-ui/core";

import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";
import {ReactComponent as AddPetSVG} from "../../../Images/addPetIcon.svg";

interface Props {
    changeCount: (number: number) => void;
    isWhiteLabel: boolean;
    petId: number;
    animalType: string;
}

const useStyle = makeStyles(() => ({
    body: {
        paddingTop: 20,
    },
    spacing: {
        paddingTop: 20,
    },
}));

const AddPhoto = ({petId, isWhiteLabel, animalType, changeCount}: Props) => {
    const classes = useStyle();
    const dispatch = useAppDispatch();
    const [uploadPhotoModalVisibility, setUploadPhotoModalVisibility] = useState(false);
    const [uploadPhotoURL, setUploadPhotoUrl] = useState("");
    const [linkToImage, setLinkToImage] = useState("");
    const imageRef = useRef(null);
    const branding = useSelector((state: RootState) => state?.branding);
    const handleImageLoadError = () => {
        setLinkToImage("");
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(getPetURLUploadImage(petId))
            .then((res) => {
                setUploadPhotoUrl(res.uploadUrl);
            });
    }, []);

    return (
        <Container className={classes.body} disableGutters={true}>
            <Typography variant="h2" gutterBottom>
                Your Pet - Add a Photo (optional)
            </Typography>
            <Grid container spacing={2}>
                <Grid xs={12} item alignContent="center" justify="center" alignItems="center">
                    <Box position="relative" width="fit-content"
                        style={{margin: "0 auto", border: colorBorder, borderRadius: 5, borderWidth: 2}}>
                        <Box
                            position="absolute"
                            right="-10px"
                            bottom="-9px"
                            borderRadius="50%"
                            bgcolor={colorBorder}
                            width="26px"
                            style={{cursor: "pointer"}}
                            height="26px"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            onClick={() => {
                                setUploadPhotoModalVisibility(true);
                            }}
                        >
                            <PencilSVG/>
                        </Box>
                        {
                            linkToImage ?
                                <img
                                    alt="pet image"
                                    ref={imageRef}
                                    src={linkToImage}
                                    onError={handleImageLoadError}
                                    width="100"
                                    height="100"
                                    style={{objectFit: "cover"}}
                                />
                                :
                                !isWhiteLabel ?
                                    createPetTypeIconLookup()[animalType] ||
                                        <Box display="flex" justifyContent="center"
                                            alignItems="center" width="100px"
                                            height="100px">
                                            <AddPetSVG/>
                                        </Box>
                                    :
                                    <Box display="flex" justifyContent="center" alignItems="center"
                                        width="100px" height="100px">
                                        <img
                                            alt="brand logo"
                                            src={branding.logo}
                                            width="100%"
                                        />
                                    </Box>
                        }
                    </Box>
                </Grid>
            </Grid>
            <Grid container justify="flex-start" spacing={2} className={classes.spacing}>
                <Grid item xs={12} sm={3}>
                    <Button
                        type="button"
                        fullWidth
                        color="secondary"
                        variant="outlined"
                        onClick={() => changeCount(1)}
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
            <UploadPhoto
                onClose={() => {
                    setUploadPhotoModalVisibility(false);
                }}
                isOpen={uploadPhotoModalVisibility}
                imageUploadURL={uploadPhotoURL}
                onLoad={(val) => {
                    dispatch(getPetURLUploadImage(petId))
                        .then((res) => {
                            setLinkToImage(res.downloadUrl);
                            setUploadPhotoUrl(res.uploadUrl);
                        });
                    setUploadPhotoModalVisibility(false);
                }}
            />
        </Container>
    );
};

export default AddPhoto;
